import React, { useState } from 'react';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import { getQueryParam } from 'utils/url';
import AttemptsContainer from './AttemptsContainer';

const AttemptsOverview = ({ scenarioId }) => {
  const groupId = getQueryParam(window.location.href, 'group_id');
  const [scenario, updateScenario] = useState({});
  const { loading } = useFetch(
    routes.ON_DEMAND_PRACTICE.CREATOR.SHOW(scenarioId, groupId),
    updateScenario,
  );

  return (
    <div className="PathViewer panel mt-30 pt-24">
      {!loading && (
        <span className="ff-ss ws-pr c-gray-light">
          {t('practice.on_demand_practice.overview.source_scenario')}
          <a
            className="c-gray-light u-linkBtn td-u ml-4"
            href={routes.ON_DEMAND_PRACTICE.CREATOR.SHOW(scenarioId)}
          >
            {scenario.title}
          </a>{' '}
          {scenario.group && (
            <>
              {t('practice.on_demand_practice.overview.and_the_group')}
              <a
                className="c-gray-light u-linkBtn td-u ml-4"
                href={routes.GROUP_SHOW(groupId)}
              >
                {scenario.group.name}
              </a>
            </>
          )}
        </span>
      )}
      <h2 className="ff-ss ws-pr mt-48 mb-24">
        {t('practice.on_demand_practice.overview.attempts_table.title')}
      </h2>
      <AttemptsContainer
        groupId={groupId}
        scenarioId={scenarioId}
        className="mt-30"
      />
    </div>
  );
};

export default props => <AttemptsOverview {...props} />;
